import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux'
import { Table, Tag, Dropdown, Badge } from 'antd'
import {
    EditOutlined,
} from '@ant-design/icons';

// Constants
import { TEMPLATE } from '../../../../constants'

// Components
import { PrimaryButton } from '../../../../components/Decoration/Button';
import { EmptyIndicator } from '../../../../components/Indicator'
import ModalStandard from '../../../../components/ModalStandard'
import SVG from '../../../../components/SVG';

// Services
import { REDUX, TIME } from '../../../../services/util'

// Redux Actions
import * as REDUX_ACTIONS from '../../../../services/redux/actions'

// Handler
import {
    table_handler,
} from '../../../../handlers'

const { getColumnSearchProps } = table_handler

const {
    STATUS_LABEL
} = TEMPLATE.VEHICLE

const { parseDate } = TIME

const VehicleGroupPanel = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const vehicleGroups = useSelector(REDUX.reduxStoreWrapper('vehicleGroups'))
    const vehicleStaticses = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID'))
    const vehicleStates = useSelector(REDUX.reduxStoreWrapper('vehicles.derivativeStateByID'))
    const users = useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID'))
    const style = useSelector(REDUX.reduxStoreWrapper('style'))
    const uid = useSelector(REDUX.reduxStoreWrapper('user.uid'))
    // const uname = useSelector(REDUX.reduxStoreWrapper('user.name'))

    const [ dataSource, setDataSource ] = useState([])
    
    const searchTextState = useState('')
    const searchedColumnState = useState('')


        const usePrevious = (value) => {
            const ref = useRef();
            useEffect(() => {
              ref.current = value;
            });
            return ref.current;
        }
    
        const prevVehicles = usePrevious(vehicleGroups.byID);
    
        const refreshDataSrc = () => {

            //         const vehicles = vehicleGroup.vehicles || []

            //         const vehicleStatus = vehicles.map(v => ({ vid: v, status: vehicleStaticses[v]?.status || 0 }))

            //         return {
            //             ...vehicleGroup,
            //             key: vehicleGroup.vhcgid,
            //             total: vehicles.length,
            //             activeVehicle: vehicleStatus.filter(v => v.status === 1)?.length || 0,
            //             inactiveVehicle: vehicleStatus.filter(v => v.status === 0)?.length || 0,
            //         }
            //     })
            //     .filter(v => {
            //         // if(v.vhcgid.includes(uid)) return true
            //         if(v.vhcgid.includes(`u#`) && !v.vhcgid.includes(uid)) return false
            //         else return true
            //       })

            const newDataSource = Object.values(vehicleGroups?.relationByUID[uid])
            // const newDataSource = Object.values(vehicleGroups?.byID)
                ?.map(vg => vehicleGroups.byID[vg])
                ?.map(vehicleGroup => {

                    const vehicles = vehicleGroup?.vehicles || []

                    const vehicleStatus = vehicles.map(v => ({ vid: v, status: vehicleStaticses[v]?.status || 0 }))

                    return {
                        ...vehicleGroup,
                        key: vehicleGroup?.vhcgid,
                        total: vehicles?.length,
                        activeVehicle: vehicleStatus.filter(v => v.status === 1)?.length || 0,
                        inactiveVehicle: vehicleStatus.filter(v => v.status === 0)?.length || 0,
                        company_name: users?.[vehicleGroup?.company]?.name
                    }
                }) || []
                // .filter(v => {
                //     // if(v.vhcgid.includes(uid)) return true
                //     if(v.vhcgid.includes(`u#`) && !v.vhcgid.includes(uid)) return false
                //     else return true
                //   })
    
            setDataSource(newDataSource)
        }

              useEffect(() => {
                // setIsLoaded(Object.values(vehicleStaticses).length > 0 || (Object.values(vehicleStaticses).length === 0 && !loading));
                // if (prevVehicles !== vehicleGroups.byID) {
                if (prevVehicles !== vehicleGroups?.relationByUID[uid]) {
                    refreshDataSrc();
                }
            // }, [vehicleGroups.byID]);
            }, [vehicleGroups?.relationByUID[uid]]);
    

    // const VehicleManagementEditOnClick = () => {}

    const vehicleGroupPanelColumns = [
        {
          title: "Vehicle Group",
          dataIndex: "vhcgid",
          render: (vhcgid) => (
              <>
                <Tag color={vehicleGroups.byID[vhcgid]?.color === '#FFFFFF' ? 'blue' : vehicleGroups.byID[vhcgid]?.color}>
                    {vehicleGroups.byID[vhcgid]?.name}
                </Tag>
              </>
          )
        },
        {
            title: "Status",
            dataIndex: "status",
            filters: Object.values(STATUS_LABEL).map(sl => ({
                text: <Tag color={STATUS_LABEL[sl.status]?.color}>{STATUS_LABEL[sl.status]?.label}</Tag>,
                value: sl.status
            })),
            onFilter: (value, record) => record.status === Number(value),
            render: (data = 1) => 
                <Tag color={STATUS_LABEL[data]?.color}>
                    {STATUS_LABEL[data]?.label}
                </Tag>,
        },
        {
            title: "Company Name",
            dataIndex: "company_name",
            ...getColumnSearchProps("Company Name", 'company_name', searchTextState, searchedColumnState),
            // render: data => users[data]?.name
          },
        {
          title: "Total Vehicles",
          dataIndex: "total",
          ...getColumnSearchProps("Total Vehicles", "total", searchTextState, searchedColumnState),
        },
        {
          title: "Status Summary",
        //   dataIndex: "summary",
          ...getColumnSearchProps("Status Summary", "summary", searchTextState, searchedColumnState),
          render: (data) => 
            <>
                <div>
                    <Badge color={'green'} style={{ marginRight: '7px' }}/>
                    {data.activeVehicle} Active
                </div>
                <div>
                    <Badge color={'grey'} style={{ marginRight: '7px' }}/>
                    {data.inactiveVehicle} Inactive
                </div>
            </>
        },
        {
            title: "Last Updated By",
            defaultSortOrder: "descend",
            // dataIndex: 'updatedAt',
            width: 250,
            sorter: (a, b) => a.updatedAt - b.updatedAt,
            render: (data) => {
                const name = users[data.updatedBy]?.name

                return (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.updatedAt))}</>
                    </>
                )
            }
          },
        {
            title: "Created By",
            width: 250,
            // dataIndex: 'createdAt',
            sorter: (a, b) => a.createdAt - b.createdAt,
            render: (data) => {
                const name = users[data.createdBy]?.name

                return (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.createdAt))}</>
                    </>
                )
            }
          },
        {
            title: "Actions",
            fixed: 'right',
            render: data => {

                const dataItems = {
                    company: data.company,
                    name: data.name,
                    color: data.color,
                    vids: data?.vehicles && [ ...data.vehicles ] || [],
                    vhcgid: data.vhcgid,
                    uid
                  }

                const items = [
                    data.name !== 'ALL' && 
                    {
                        key: '1',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => navigate(`/update/vehiclegroup`, {state: { data: { ...data, title: 'Edit' } }})}
                            >
                                Edit
                            </span>
                    },
                    {
                        key: '2',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_vehicleGroups.update_vehicle_group_request({
                                    ...dataItems,
                                    status: 1
                                }))
                            }}
                            disabled={data.status === 1}
                            title={'Mark as active'}
                            content={'You are about to mark this vehicle as active.'}
                            subcontent={`${data.name || '-'}`}
                            // icon={<></>}
                        >
                            Mark as active
                        </ModalStandard>
                    },
                    {
                        key: '3',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                dispatch(REDUX_ACTIONS.v3_vehicleGroups.update_vehicle_group_request({
                                    ...dataItems,
                                    status: 0
                                }))
                            }}
                            disabled={data.status === 0}
                            title={'Mark as inactive'}
                            content={'You are about to mark this vehicle as inactive.'}
                            subcontent={`${data.name || '-'}`}
                            // icon={<></>}
                        >
                            Mark as inactive
                        </ModalStandard>
                    }
                ]

                return (
                    <Dropdown menu={{ items }}>
                        <EditOutlined />
                    </Dropdown>
                )

            }
          }
      ];

    const expandedVehicleGroupRender = (record) => {

        const columns  = [
            {
                title: 'Vehicle Plate',
                dataIndex: 'plate'
            },
            {
                title: "Status",
                dataIndex: "status",
                // filters: Object.values(STATUS_LABEL).map(sl => ({
                //     text: <Tag color={STATUS_LABEL[sl.status]?.color}>{STATUS_LABEL[sl.status]?.label}</Tag>,
                //     value: sl.status
                // })),
                // onFilter: (value, record) => record.status === Number(value),
                render: (data = 1) => 
                    <Tag color={STATUS_LABEL[data]?.color}>
                        {STATUS_LABEL[data]?.label}
                    </Tag>,
            },
            {
                title: 'Current Movement Status',
                dataIndex: 'transitStatus',
                render: (data) =>  
                    data
                    &&
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <SVG 
                            viewBox="0 0 14 14" 
                            fill="none" 
                            size="20"
                            name={`${data.toLowerCase()}-square`}
                        />
                        <span>{data?.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}</span>
                    </div>
            },
            {
                title: 'Actions',
                fixed: 'right',
                dataIndex: 'vid',
                render: (data) => (
                    <span
                        aria-hidden='true'
                        className='ButtonLink'
                        onClick={() => dispatch(REDUX_ACTIONS.v3_vehicleGroups.unassign_vehicle_from_group_request([ data ], record.vhcgid))}
                    >
                        Remove
                    </span>
                )
            },
        ]

        const dataSource = record?.vehicles?.length && record?.vehicles?.map(vid => ({
            vid,
            key: vid,
            plate: vehicleStaticses[vid]?.plate,
            status: vehicleStaticses[vid]?.status,
            transitStatus: vehicleStates[vid]?.transitStatus
        }))

        return <Table dataSource={dataSource} columns={columns} />
    }

    return (
        <div >
            <PrimaryButton htmlType={'submit'} style={{ float: 'right', marginBottom: '15px' }} onClick={() => navigate (`/create/vehiclegroup`)}>+ Create vehicle group</PrimaryButton>
            {
                dataSource.length > 0 ?
                    <Table
                        loading={style.loading.general}
                        columns={vehicleGroupPanelColumns && vehicleGroupPanelColumns.filter(c => !c.isHidden)}
                        dataSource={dataSource}
                        pagination={true}
                        scroll={{
                            y: window.innerHeight,
                            x: vehicleGroupPanelColumns && vehicleGroupPanelColumns.length * 200
                        }}
                        expandable={{
                            expandedRowRender: (record) => expandedVehicleGroupRender(record)
                        }}
                    /> 
                :
                    <EmptyIndicator />
            }
        </div>
    )
}

export default VehicleGroupPanel